import CampaignMappingFieldResourcePagingResultModel from '../../generated/types/model/resource/CampaignMappingFieldResourcePagingResultModel';

export default class CampaignMappingFieldResourcePagingResultViewModel extends CampaignMappingFieldResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
